import Env from '../base/env.js';
import Channels from '../base/channels.js';
import UISwitcher from '../ui/UIswitcher';
import { EmitCartOpen, EmitCartClose } from '../modules/CartEvents';

export default class UI {
  constructor() {
    this.detectAppHeight();
    this.resetEnv();
    this.uiSwitch = new UISwitcher();

    //? Cart events
    EmitCartClose();
    EmitCartOpen();
  }

  appHeight() {
    const doc = document.documentElement;
    doc.style.setProperty('--app-height', `${window.innerHeight}px`);
  }

  detectAppHeight() {
    this.appHeight();
    Channels.on('window::smartresize', this.appHeight);
  }

  resetEnv() {
    Channels.on('statechange::before', function () {
      Env.$html.classList.remove('mainnav--isOpened');
      Env.$html.classList.remove('subnav--isOpened');
    });
    Channels.on('statechange::ready', (current, old, container) => {
      Env.isVisiting = true;
      // Env.$html.classList.remove('skin--isWhite')
      // Env.$html.classList.remove('skin--isDark')
      // Env.$mainNav.classList.remove('is--active');
      // Env.$html.classList.remove('mainnav--isOpened')
    });
    Channels.on('statechange::finalize', () => {});
  }
}
